import { render, staticRenderFns } from "./Dejavnosti.vue?vue&type=template&id=3acf22d4&"
import script from "./Dejavnosti.vue?vue&type=script&lang=js&"
export * from "./Dejavnosti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports